import { Controller } from "@hotwired/stimulus"

// TODO attempted a code style upgrade (see history) -- failed midway or something

// TODO all these must come from the server (through data attrs on controller el)
const MAIL_SUBJECT_PREFIX = 'Re: ';
const MAIL_ADDRESS = 'work@costashapiro.com'; // TODO! softcode this

export default class extends Controller {
  connect() {
    this.contactEl = document.getElementById('contact')
    window.addEventListener("hashchange", (e) => this._restoreFromHash(e))
    if (document.getElementById(location.hash.substr(1))) {
      this._restoreFromHash({newURL: location})
    } else {
      let el = document.getElementsByClassName('public-announcement')[0]
      if (el) {
        setTimeout(() => location.hash = el.id, 0)
      }  // NOTE else: no announcements ;(
    }
  }

  writing() {
    // TODO! unmagic that number
    let mailSubject = MAIL_SUBJECT_PREFIX + this.contactEl.parentElement.textContent.split('\n')[6];
    let mailBody = this.contactEl.querySelector('.message').value;
    // BUGBUGBUG in iOS: https://developer.apple.com/forums/thread/681023
    location.href =
      `mailto:${encodeURIComponent(MAIL_ADDRESS)}?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody).replace('%0A', '%0D%0A')}`;
  }

  _restoreFromHash(e) {
    let el = document.getElementById(this._hashIdFromEvent(e))
    if (el && this.contactEl) {
      el.appendChild(this.contactEl)
    }
  }

  _hashIdFromEvent(e) {
    return new URL(e.newURL).hash.substr(1)
  }
}
